// extracted by mini-css-extract-plugin
module.exports = {"socialContainer":"u8UD0iJb","social":"_3snvf6jP","link":"_2FrFUDqC"};